import { showToast } from './Toast.js';

/**
 * Adds a keyboard shortcut "C" that copies current mouse position (in scene world coords)
 * to clipboard and shows a toast.
 *
 * Usage: in scene.create(), call once: attachCoordsDebug(this);
 */
export function attachCoordsDebug(scene) {
  const handler = () => {
    const p = scene.input.activePointer;
    const x = Math.round(p.worldX);
    const y = Math.round(p.worldY);
    const text = `${x}, ${y}`;
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).catch(() => {});
    }
    showToast(scene, `📋 Skopiowano: (${text})`);
  };
  scene.input.keyboard.on('keydown-C', handler);
  scene.events.on('shutdown', () => scene.input.keyboard.off('keydown-C', handler));
}
